export default __webpack_public_path__ + "static/media/5fd54545bf6dfcd8.737565c2ecb85bbc1219582a0b4fb05a.svg";